import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { Link } from "react-router";
import { getAllowedRoutes } from "../../routes";
import { Logo } from "../../components/Logo";
import { useContext } from "react";
import { UserContext } from "../../contexts/userContext";

/*
const generateSidebarMenu = (routes, parentPath = "") => {
  
  return routes.map((route) => {
    if (route.skipRender) {
      return null;
    }
    const path = route.linkPath || route.path;

    if (route.children) {
      return (
        <Menu.SubMenu
          key={path}
          title={
            <span>
              {route.icon}
              <span>{route.title}</span>
            </span>
          }
        >
          {generateSidebarMenu(route.children, path)}
        </Menu.SubMenu>
      );
    }

    const fullPath = parentPath + typeof path !== "string" ? path[1] : path;
    return (
      <Menu.Item key={fullPath}>
        <Link to={fullPath}>
          {!parentPath && route.icon}
          <span>{route.title}</span>
        </Link>
      </Menu.Item>
    );
  });
};
*/

const generateSidebarItems = (routes, idx) => {
	return routes.filter(route => !Boolean(route.skipRender)).map(route => ({
		key: route.path,
		icon: route.icon,
		label: <Link to={route.path}>{route.title}</Link>
	}))
}

export const Sidebar = ({ permission,isSmallScreen, currentPage }) => {
  const wasCollapsed = localStorage.getItem("collapsed");
  const { userInfo } = useContext(UserContext);
  const [collapsed, setCollapsed] = useState(
    wasCollapsed ? wasCollapsed === "true" : window.innerWidth < 1400
  );

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
    localStorage.setItem("collapsed", collapsed);
  };

  const curPage = currentPage === "/" ? "/schedule-reports" : currentPage;
  //const additionalProps = isSmallScreen? {} : { breakpoint: "lg", collapsedWidth: 0 };
  const additionalProps = {};

  return (
    <Layout.Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      {...additionalProps}
    >
      <Link to="/">
        <Logo collapsed={collapsed} />
      </Link>

			{/*
      <Menu theme="dark" mode="inline" id="menu" selectedKeys={curPage}>
        {generateSidebarMenu(getAllowedRoutes(userInfo.type))}
      </Menu>
			*/}
			<Menu
				theme="dark"
				mode="inline"
				id="menu"
				selectedKeys={curPage}
				items={generateSidebarItems(getAllowedRoutes(userInfo.type))}
			/>
    </Layout.Sider>
  );
};
